/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Rename_ChatInputs */



/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Assistant_Rename_ChatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_rename_chat = /** @type {((inputs?: Assistant_Rename_ChatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Rename_ChatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rebaptiser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Umbenennen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rinominare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переименовать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rebautizar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重命名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("名前を変更する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नाम बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renomear")
	return /** @type {LocalizedString} */ ("Rename")
});